import React from "react";
import Navbar from "../../components/Navbar";
import Typography from "@mui/material/Typography";
import { Box, Container } from "@mui/material";
import "./PrivacyPolicy.scss";
import Footer from "../../components/Footer";

const ClientPrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <Box className="privacy_policy">
        <Container maxWidth="lg">
          <Typography variant="h1" component="h1">
            Declaração de Privacidade Whasapp
          </Typography>
          <div style={{ padding: '20px', lineHeight: '1.6', fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
      <h2>1. Introdução</h2>
      <p>
        Esses termos e condições de uso são um contrato vinculativo entre você e WASH SERVIÇOS DE TECNOLOGIA LTDA.,
        sociedade empresária limitada, inscrita no CNPJ/MF sob o nº 52.472.237/0001-79, com sede na Rua Maratona,
        285, apto. 104, bloco A, Vila Alexandria, São Paulo – SP, CEP 04635-04 (Wash Pass).
      </p>
      <p>
        O Wash Pass oferece uma maneira conveniente e econômica de manter seu veículo limpo e bem cuidado, onde quer
        que você esteja. Com nosso compromisso de qualidade e praticidade, oferecemos pacotes de serviços de lavagens
        automotivas mensais, nossa atual oferta é um pacote que permite lavagens externas e internas por mês,
        adaptadas aos tamanhos de veículos P, M, G e GG e, conforme o plano aderido. Estes Termos e Condições
        estabelecem as diretrizes que regem o uso de nossos serviços, garantindo uma experiência segura e
        satisfatória para todos os nossos usuários. Ao acessar e utilizar o Wash Pass, você concorda em cumprir os
        seguintes termos e condições. Leia-os atentamente e entre em contato conosco se tiver alguma dúvida.
      </p>
      <h2>2. Definições</h2>
      <p>
        No contexto do Wash Pass, utilizamos diversos termos que são essenciais para compreender o funcionamento da
        nossa plataforma. O Usuário se refere ao cliente final que utiliza o aplicativo para solicitar serviços de
        lavagem de carros, sendo este o Proprietário do Veículo. Os Estabelecimentos Parceiros são os lava-jatos
        e centros de estética automotiva que se associam à nossa plataforma para oferecer serviços de lavagem.
      </p>
      <h2>3. Aceitação dos Termos</h2>
      <p>
        Para garantir que todos os usuários tenham uma experiência segura e satisfatória no Wash Pass, é fundamental
        que cada indivíduo compreenda e aceite nossos Termos e Condições antes de usar nossos serviços.
      </p>
      <h2>4. Modificações dos Termos</h2>
      <p>
        Entendemos que as circunstâncias e necessidades podem evoluir ao longo do tempo, e, por isso, reservamos o
        direito de revisar e atualizar periodicamente os nossos Termos e Condições.
      </p>
      <h2>5. Descrição dos Serviços</h2>
      <p>
        A plataforma Wash Pass oferece serviços de lavagens automotivas, busca por estabelecimentos parceiros e
        avaliação dos serviços prestados por esses estabelecimentos. Os serviços podem variar de acordo com o plano
        contratado.
      </p>
      <ul>
        <li><strong>Lavagens Completas:</strong> Limpeza completa da parte externa do veículo e limpeza do interior do veículo, incluindo aspiração de tapetes e limpeza de painéis. </li>
      </ul>
      <h2>6. Cadastro de Usuário</h2>
      <p>
        O usuário deve baixar o aplicativo Wash Pass, criar uma conta pessoal e aceitar os Termos e Condições para
        começar a usar os serviços.
      </p>
      <h2>7. Assinaturas</h2>
      <p>
        Para usufruir dos serviços oferecidos, o usuário precisa selecionar e assinar um plano, seguindo as condições
        descritas na plataforma.
      </p>
      <h2>8. Obrigações e Conduta do Usuário</h2>
      <p>
        O usuário deve usar a plataforma de maneira responsável, respeitar outros usuários e parceiros, e fornecer
        informações precisas durante o cadastro.
      </p>
      <h2>9. Cancelamento da Assinatura</h2>
      <p>
        O cancelamento pode ser realizado a qualquer momento, seguindo as instruções disponíveis na plataforma. A
        assinatura permanecerá ativa até a próxima data de faturamento.
      </p>
      <h2>10. Privacidade e Proteção de Dados</h2>
      <p>
        Os dados dos usuários são armazenados em bancos de dados seguros, protegidos por criptografia e utilizados
        para análises e campanhas de marketing.
      </p>
      <h2>11. Direitos de Propriedade Intelectual</h2>
      <p>
        Todo o conteúdo da plataforma Wash Pass está protegido por direitos de propriedade intelectual. Qualquer uso
        não autorizado será penalizado conforme a lei.
      </p>
      <h2>12. Limitações de Responsabilidade</h2>
      <p>
        A Wash Pass não se responsabiliza por danos decorrentes do uso da plataforma, incluindo falhas nos serviços
        prestados por parceiros.
      </p>
      <h2>13. Resolução de Conflitos</h2>
      <p>
        Todos os conflitos relacionados ao uso da plataforma serão resolvidos de acordo com as leis brasileiras,
        preferencialmente no foro de São Paulo.
      </p>
      <h2>14. Uso de Localização</h2>
      <p>O aplicativo Wash valoriza sua privacidade e transparência em relação aos dados coletados. Esta seção descreve como utilizamos as informações de localização e os propósitos associados.</p>

      <h4>Coleta e Uso de Dados de Localização</h4>
      <p>
        O app Wash coleta dados de localização para fornecer uma experiência personalizada. Isso inclui:
      </p>
      <ul>
        <li>Identificar lava-rápidos próximos com base na sua localização atual.</li>
        <li>Enviar notificações sobre promoções e serviços exclusivos ao passar por lava-rápidos parceiros, mesmo quando o aplicativo está em segundo plano.</li>
      </ul>

      <h4>Compartilhamento de Dados de Localização</h4>
      <p>
        Os dados de localização são utilizados exclusivamente para oferecer os serviços descritos acima e não são compartilhados com terceiros, exceto conforme necessário para fornecer as funcionalidades do app (por exemplo, serviços de mapa e navegação).
      </p>

      <h4>Consentimento e Controle</h4>
      <p>
        O uso da localização em segundo plano é ativado somente com o seu consentimento explícito. Você pode revogar essa permissão a qualquer momento nas configurações do dispositivo, mas isso pode limitar algumas funcionalidades do app.
      </p>

      <h4>Segurança dos Dados</h4>
      <p>
        Os dados de localização são armazenados de forma segura e utilizados apenas pelo período necessário para proporcionar os serviços mencionados.
      </p>

      <p>
        Se tiver dúvidas ou preocupações sobre o uso da sua localização, entre em contato conosco pelo e-mail: suporte@wash.app.br.
      </p>
      <p>
       Coletamos sua localização para encontrar a lava-rápido parceiro mais próxima, otimizando sua experiência e entregando parceiros aptos para atender a sua lavagem.
      </p>

      <h2>15. Contato</h2>
      <p>
        Para dúvidas, visite nossa Central de Ajuda.
      </p>
    </div>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default ClientPrivacyPolicy;
